import React from 'react';
import Dialog from 'material-ui/Dialog';
import {DELETE_CATEGORY_TYPE, DELETE_TUTORIAL_TYPE} from 'constants/adminPupups';
import {inject} from 'mobx-react';
import {observe} from 'mobx';
import HttpClient from 'services/HttpClient';
import {withRouter} from 'react-router-dom';
const DELETE_CATEGORY = '/api/v1/categories/';
const DELETE_TURORIAL = '/api/v1/tutorials/';

@withRouter
@inject('editableCategoryStore')
@inject('categoryStore')
@inject('alertStore')
export default class DeleteCategoryPopup extends React.Component {

  state = {open: false};

  componentWillMount(){
    this.listener = observe(this.props.editableCategoryStore, 'type', () => {
      if(this.props.editableCategoryStore.type.valueOf() === DELETE_CATEGORY_TYPE ||
        this.props.editableCategoryStore.type.valueOf() === DELETE_TUTORIAL_TYPE){
        this.setState({open: true,
          type: this.props.editableCategoryStore.type.valueOf(),
          id: this.props.editableCategoryStore.object_id})
      }
    })
  }

  handleClose = () => {
    this.setState({open: false});
  };

  handleDelete = e => {
    e.preventDefault();
    this.state.type && this.state.type === DELETE_TUTORIAL_TYPE ? this.deleteTutorial() : this.deleteCategory()
  };

  deleteCategory = () => {
    new HttpClient().delete(DELETE_CATEGORY + this.state.id).then( () => {
      this.props.categoryStore.deleteCategory(this.state.id);
      this.handleClose();
      this.props.alertStore.success('Successfully deleted');
    }).catch(() => {
      this.handleClose();
      this.props.alertStore.success('Something went wrong');
    })
  };

  deleteTutorial = () => {
    new HttpClient().delete(DELETE_TURORIAL + this.state.id.itemId).then( (data) => {
      if(!this.props.location.search)
        this.props.categoryStore.deleteTutorial(this.state.id.categoryId, data.body.data.questions);
      else
        this.props.categoryStore.deleteTutorialOnShow(this.state.id.categoryId, this.state.id.itemId);
      this.handleClose();
      this.props.alertStore.success('Successfully deleted');
    }).catch(() => {
      this.handleClose();
      this.props.alertStore.success('Something went wrong');
    })
  };

  modalTitle = () => {
    return this.state.type && (this.state.type === DELETE_TUTORIAL_TYPE ? 'Delete Tutorial?' : 'Delete Category?')
  };

  categoryText = () => {
    const title = this.state.id && this.props.categoryStore.getCategoryById(this.state.id) && this.props.categoryStore.getCategoryById(this.state.id).title || '';
    return `Are you sure to delete category «${title}»? All video tutorials presented in this
            category will be deleted too.`
  };

  tutorialText = () => {
    const title = this.state.id &&
      this.props.categoryStore.getTutorialById(this.state.id.categoryId,this.state.id.itemId) &&
      this.props.categoryStore.getTutorialById(this.state.id.categoryId,this.state.id.itemId ).title || '';
    return `Are you sure to delete video tutorial «${title}»? `
  };

  render() {
    return (
      <div>
        <Dialog
          className="modal-wrapper"
          title={this.modalTitle() || ''}
          modal={true}
          open={this.state.open}>
          <div className="text">{this.state.id &&
          this.state.type === DELETE_TUTORIAL_TYPE ?
          this.tutorialText() :
          this.categoryText()
          }
          </div>
          <form className="create-category form-modal">
            <div className="button-set">
              <button className="btn gray small transparanted cancel-btn" type="button"
                      onClick={this.handleClose}>No, thanks
              </button>
              <button className="btn gray small transparanted delete-btn" type="button"
                      onClick={this.handleDelete}>Delete
              </button>
            </div>
          </form>
        </Dialog>
      </div>)

  }
}



// WEBPACK FOOTER //
// ./src/modules/categories/components/DeleteCategoryPopup.js